import { render, staticRenderFns } from "./device-info.vue?vue&type=template&id=3ff67ff7&scoped=true"
import script from "./device-info.vue?vue&type=script&lang=js"
export * from "./device-info.vue?vue&type=script&lang=js"
import style0 from "./device-info.vue?vue&type=style&index=0&id=3ff67ff7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff67ff7",
  null
  
)

export default component.exports